import { useState } from 'react'
import { ProjectInterface } from '../../../interfaces/ProjectInterface'
import { KeywordResponse } from '../../../types'

const ThinContentModel = () => {
  const [ isLoading, setIsLoading ] = useState<Record<string, boolean>>({ search: false, export: false, projects: false, keywords: false });
  const [ projectsData, setProjectsData ] = useState<ProjectInterface>()
  const [ projectSelected, setProjectSelected ] = useState('')
  const [ keywordsData, setKeywordsData ] = useState<KeywordResponse>()

  // Pagination and Sorting in server side
  const[ filter, setFilter ] = useState(new Map())

  return {
    isLoading, setIsLoading,
    projectsData, setProjectsData,
    projectSelected, setProjectSelected,
    keywordsData, setKeywordsData,
    filter, setFilter
  }
}

export default ThinContentModel